module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/710afc61cce8380eeb56abd43978c4f5.png";